import _findIndex from 'lodash/findIndex';

import initialState from './initialState';
import actionTypes from './actionTypes';

const infiniteTablePropertiesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_TABLE_META_PROPERTIES_SUCCESS: {
            const { columns, records, contextMenuItems, explorerViews, totalRowCount, tableName, eventMonitorId } = action.payload;
            return {
                ...state,
                agGridDefaultColDef: columns,
                agGridRowData: [],
                agGridContextMenuItems: contextMenuItems,
                totalRowCount: totalRowCount,
                explorerViews: explorerViews,
                tableName: tableName,
                eventMonitorId: eventMonitorId,
            };
        }
        case actionTypes.GET_TABLE_META_PROPERTIES_SNAPSHOT_SUCCESS: {
            const { columns, records, contextMenuItems, explorerViews, totalRowCount, tableName, eventMonitorId } = action.payload;
            return {
                ...state,
                spagGridDefaultColDef: columns,
                spagGridRowData: [],
                spagGridContextMenuItems: contextMenuItems,
                sptotalRowCount: totalRowCount,
                spexplorerViews: explorerViews,
                sptableName: tableName,
            };
        }
        case actionTypes.GET_TABLE_META_PROPERTIES_SUCCESS_HISTORY: {
            const { columns, records, contextMenuItems, explorerViews, totalRowCount, tableName } = action.payload;
            return {
                ...state,
                agGridDefaultColDefHistory: columns,
            };
        }
        case actionTypes.GET_TABLE_META_PROPERTIES_VIEWSIGNOFF_SUCCESS: {
            const { columns, records, contextMenuItems, explorerViews, totalRowCount, tableName, eventMonitorId } = action.payload;
            return {
                ...state,
                viewsignoffagGridDefaultColDef: columns,
                viewsignoffagGridRowData: [],
                viewsignoffagGridContextMenuItems: contextMenuItems,
                viewsignofftotalRowCount: totalRowCount,
                viewsignoffexplorerViews: explorerViews,
                viewsignofftableName: tableName,
            };
        }
        case actionTypes.GET_SOURCE_EXPLORER_VIEWS_SUCCESS:
            return {
                ...state,
                explorerViews: action.payload,
            };
        case actionTypes.GET_SUMMARY_AUDIT_VIEWS_SUCCESS:
            return {
                ...state,
                summaryAuditViews: action.payload,
            };
        case actionTypes.GET_VIEW_RECORDS_SUCCESS: {
            return {
                ...state,
                virtualColumns: action.payload,
            };
        }
        case actionTypes.GET_FILES_FROM_SERVER: {
            return {
                ...state,
                filesFromServer: action.payload,
            };
        }
        case actionTypes.GET_FILES_FROM_CONTAINER: {
            return {
                ...state,
                filesFromContainer: action.payload,
            };
        }
        default:
            return state;
    }
};

export default infiniteTablePropertiesReducer;
